import { InformationBannerProps } from "../../InformationBanner";

export enum EFeedbackProgress {
  Low,
  Medium,
  High
}

export interface FeedbackResultCardProps {
  answer?: string;
  icon?: string;
  informationBanner?: InformationBannerProps;
  progress?: EFeedbackProgress; 
  question?: string;
  title: string;
}